const BASE_IMAGES_URL = 'https://assets1.cleartax-cdn.com/cleartax/images/';

export const HOME_BLUE_ICON = `${BASE_IMAGES_URL}1616528619_purplehome.png`;
export const HOME_GREY_ICON = `${BASE_IMAGES_URL}1616528565_greyhome.png`;
export const MIS_BLUE_ICON = `${BASE_IMAGES_URL}1616528660_purplemis.png`;
export const MIS_GREY_ICON = `${BASE_IMAGES_URL}1616528032_greymis.png`;
export const QR_BLUE_ICON = `${BASE_IMAGES_URL}1616528996_purpleqrcodetabbar.png`;
export const QR_GREY_ICON = `${BASE_IMAGES_URL}1616528148_greyqrcodetabbar.png`;
export const INVOICE_BLUE_ICON = `${BASE_IMAGES_URL}1616528841_purpleinvoice.png`;
export const INVOICE_GREY_ICON = `${BASE_IMAGES_URL}1616528083_greyinvoice.png`;
export const ALERTS_BLUE_ICON = `${BASE_IMAGES_URL}1616528877_purplealert.png`;
export const ALERTS_GREY_ICON = `${BASE_IMAGES_URL}1616526780_greyalert.png`;
export const FORWARD_ARROW = `${BASE_IMAGES_URL}1614764425_forward_arrow.png`
export const HAMBURGER = `${BASE_IMAGES_URL}1614773054_hamburger.png`;
export const BLUE_ARROW = `${BASE_IMAGES_URL}1614792861_arrowcirclerightfill.svg`;
export const WHITE_CHEVRON = `${BASE_IMAGES_URL}1616578929_whitechevronright.png`;
export const DOWNLOAD_ICON = `${BASE_IMAGES_URL}1616519590_download.png`;
export const SHARE_ICON =`${BASE_IMAGES_URL}1614936333_share.svg`;
export const BLACK_ARROW = `${BASE_IMAGES_URL}1617882154_blackchevron.png`;
export const YELLOW_ARROW = `${BASE_IMAGES_URL}1615137706_yellow_arrow.png`;
export const RED_ARROW = `${BASE_IMAGES_URL}1615137786_red_arrow.png`;
export const BIZ_ICON = `${BASE_IMAGES_URL}1616796416_building.png`;
export const GALLERY_ICON = `${BASE_IMAGES_URL}1615380951_gallery.png`;
export const FLASH_ICON = `${BASE_IMAGES_URL}1615381013_flash.png`;
export const VECTOR_BACK_ICON = `${BASE_IMAGES_URL}1617200071_black_chevron.png`;
export const INTRO_PAGE_LOGO = `${BASE_IMAGES_URL}1616414912_pwa_logo.png`;
export const INTRO_CIRCLES = `${BASE_IMAGES_URL}1616662712_circles3.png`;
export const INTRO_PAGE_DOTS = `${BASE_IMAGES_URL}1615645716_login_dots.png`;
export const BACK_BLUE_ARROW = `${BASE_IMAGES_URL}1616417574_purplearrowleft.png`;
export const EYE_OFF = `${BASE_IMAGES_URL}1616416410_eyeoff.png`;
export const GREEN_TICK_MARK = `${BASE_IMAGES_URL}1615715912_approvalgreentick.png`;
export const SHARE_BUTTON_ICON = `${BASE_IMAGES_URL}1617257782_whiteshare.png`;
export const DOWNLOAD_BUTTON_ICON = `${BASE_IMAGES_URL}1617258191_pdf.png`;
export const QR_ERROR = `${BASE_IMAGES_URL}1617258562_errorqr.png`
export const COMING_SOON_BANNER = `${BASE_IMAGES_URL}1616758396_comingsoonbanner.png`;
export const INV_ILLUSTRATION = `${BASE_IMAGES_URL}1616770450_invoiceillustration.png`;
export const NOTIF_ILLUSTRATION = `${BASE_IMAGES_URL}1616760177_notificationillustration.png`;
export const TRUCK = `${BASE_IMAGES_URL}1616770475_truckillustration.png`;
export const CROSS = `${BASE_IMAGES_URL}1617172024_cross.png`;
export const BLUE_TICK_MARK = `${BASE_IMAGES_URL}1617169764_bluetick.png`;
export const WHITE = `${BASE_IMAGES_URL}1617171876_white.png`;
export const SEARCH = `${BASE_IMAGES_URL}1617176871_search.png`;
export const CANCEL_SEARCH = `${BASE_IMAGES_URL}1617194102_cancel.png`;
export const LOADER_BLUE = `${BASE_IMAGES_URL}1617198117_loadingblue.svg`;
export const BAD_GREY = `${BASE_IMAGES_URL}1620967976_blackandwhitebad.png`;
export const BAD_COLOR=`${BASE_IMAGES_URL}1620968209_coloursad.png`;
export const OKAY_GREY=`${BASE_IMAGES_URL}1620968125_blackandwhiteokay.png`;
export const OKAY_COLOR =`${BASE_IMAGES_URL}1620968264_colourokay.png`;
export const GREAT_GREY = `${BASE_IMAGES_URL}1620968162_blackandwhitehappy.png`;
export const GREAT_COLOR = `${BASE_IMAGES_URL}1620968298_colourhappy.png`;
export const GREEN_CHECK_MARK = `${BASE_IMAGES_URL}1618987880_checkmarkgreen.png`;
export const DOWNLOAD_ICON_BLUE = `${BASE_IMAGES_URL}1617872317_blue_download.png`;
export const SHARE_ICON_BLUE = `${BASE_IMAGES_URL}1617873047_blue_share.png`;
export const NO_INVOICE_FOUND = `${BASE_IMAGES_URL}1620888952_no_search.png`;
export const NO_BIZ_FOUND = `${BASE_IMAGES_URL}1620198110_lock_no_biz.png`;
export const INV_DNLD_SUCCESS = `${BASE_IMAGES_URL}1620299187_invoicedownloadedillustration.png`;
export const TOAST_ERROR =`${BASE_IMAGES_URL}1621252549_warning.png`;
export const TOAST_CHECK_MARK =`${BASE_IMAGES_URL}1621257096_toast_check_mark.png`;
export const SOMETHING_WRONG =`${BASE_IMAGES_URL}1621326553_somethingwentwrong.png`;
export const RELOAD_PAGE =`${BASE_IMAGES_URL}1621327451_reload.png`;
export const BUSINESS =`${BASE_IMAGES_URL}1621946756_business_bottom_draw.png`;
export const COPY_ICON = `https://assets1.cleartax-cdn.com/cleartax-gst/images/1608004549_copy_image.png`;
export const CALENDAR = `https://assets1.cleartax-cdn.com/cleartax/images/1616520351_calendar.png`;
export const EYE_ON = `https://assets1.cleartax-cdn.com/cleartax/images/1616415843_eyeon.png`;
